/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonBtcStakingOverviewRequest = {
    sortDirection?: BabylonBtcStakingOverviewRequest.sortDirection;
    page?: number;
    size?: number;
    address: string;
    sortField?: BabylonBtcStakingOverviewRequest.sortField;
};

export namespace BabylonBtcStakingOverviewRequest {

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }

    export enum sortField {
        STAKING_VALUE = 'STAKING_VALUE',
        STAKING_COUNT = 'STAKING_COUNT',
    }


}

